import React, { useEffect, useRef, useState } from "react";
import {
  GridFunctionsProp,
  calcSize,
} from "bodycodi/cmap/app/components/common/imageEditor/imageEditer";
import { isEmpty, findIndex } from "../../../js/common";
import gridBlack from "bodycodi/cmap/app/svg/grid_black.svg";
import gridWhite from "bodycodi/cmap/app/svg/grid_white.svg";
import xIcon from "bodycodi/cmap/app/svg/grid-controller-x-icon.svg";

type ModePickerProp = {
  onChange: Function;
  mode1: string;
};

const GridControll = ({
  editor,
  setMode,
  setActiveGrid,
  activeGrid,
  editorDiv,
  multiple,
  setMultiple,
  mode1,
  setMode1,
  setLoadImage,
}: GridFunctionsProp) => {
  const wrap = useRef<HTMLDivElement>(null);
  const [girdData, setGridData] = useState("");

  useEffect(() => {
    wrap.current?.classList.add("open");
  }, []);

  useEffect(() => {
    if (mode1 === "") {
      if (!isEmpty(activeGrid)) {
        editor.removeObject(activeGrid).then(() => {});
        setActiveGrid({});
        setGridData("");
      }
    } else {
      convertSvgToPng();
    }
  }, [multiple, mode1]);

  useEffect(() => {
    if (!isEmpty(girdData)) {
      if (isEmpty(activeGrid)) {
        setLoadImage(false);
        editor
          .addImageObject(girdData)
          .then((objectProps: any) => {
            setActiveGrid(objectProps.id);
            editor.setObjectProperties(objectProps.id);
            setLoadImage(true);
          })
          .catch(() => {
            setLoadImage(true);
          });
      } else {
        setLoadImage(false);
        editor.removeObject(activeGrid).then(() => {
          editor
            .addImageObject(girdData)
            .then((objectProps: any) => {
              setActiveGrid(objectProps.id);
              setLoadImage(true);
              editor.setObjectProperties(objectProps.id);
            })
            .catch(() => {
              setLoadImage(true);
            });
        });
      }
    }
  }, [girdData]);

  const convertSvgToPng = () => {
    const canvas = document.createElement("canvas") as HTMLCanvasElement;
    const context = canvas.getContext("2d");
    const image: any = new Image();
    image.onload = () => {
      const canvasSize = calcSize(image, editor);
      canvas.width = canvasSize.width * multiple;
      canvas.height = canvasSize.height * multiple;
      context!.drawImage(image, 0, 0, canvasSize.width * multiple, canvasSize.height * multiple);
      setGridData(canvas.toDataURL("image/png", 0.1));
    };

    if (mode1 === "WHITE") {
      image.src = gridWhite;
    } else {
      image.src = gridBlack;
    }
  };

  const close = () => {
    wrap.current?.classList.remove("open");
    wrap.current?.classList.add("close");
    editor.stopDrawingMode();
    setTimeout(() => {
      setMode("");
    }, 100);
  };

  const clicConfirm = () => {
    close();
  };

  const changeMode = (s: string) => {
    setMode1(s);
  };

  const clickMultiple = (i: number) => () => {
    setMultiple(i);
  };

  return (
    <div className="custon-editor-feature-detail-wrap" ref={wrap}>
      <div className="custon-editor-feature-detail">
        <div className="grid-controller">
          {mode1 !== "" && (
            <div className="multiple-list">
              <div
                className={"multiple" + (multiple === 1 ? " active" : "")}
                onClick={clickMultiple(1)}
              >
                <img src={xIcon} />
                <span>1</span>
              </div>
              <div
                className={"multiple" + (multiple === 2 ? " active" : "")}
                onClick={clickMultiple(2)}
              >
                <img src={xIcon} />
                <span>2</span>
              </div>
              <div
                className={"multiple" + (multiple === 3 ? " active" : "")}
                onClick={clickMultiple(3)}
              >
                <img src={xIcon} />
                <span>3</span>
              </div>
            </div>
          )}
          <div className="mode-picker-wrap">
            <ModePicker onChange={changeMode} mode1={mode1} />
          </div>
        </div>
      </div>
    </div>
  );
};

const ModePicker = ({ onChange, mode1 }: ModePickerProp) => {
  const [style, setStyle] = useState({
    left: "4px",
    width: "",
  });
  const [current, setCurrent] = useState("none");
  const picker = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const find = picker.current?.querySelector("." + current) as HTMLDivElement;
    setStyle({ left: find?.offsetLeft + "px", width: find?.clientWidth + "px" });
  }, [mode1]);

  const changeMode = (mode: string, current: string) => () => {
    onChange(mode);
    setCurrent(current);
  };

  return (
    <div className="mode-picker" ref={picker}>
      <div className={"pick none" + (mode1 === "" ? " ac" : "")} onClick={changeMode("", "none")}>
        없음
      </div>
      <div
        className={"pick white" + (mode1 === "WHITE" ? " ac" : "")}
        onClick={changeMode("WHITE", "white")}
      >
        화이트
      </div>
      <div
        className={"pick black" + (mode1 === "BLACK" ? " ac" : "")}
        onClick={changeMode("BLACK", "black")}
      >
        블랙
      </div>
      <div className="active" style={style}></div>
    </div>
  );
};

export default GridControll;
